export const SITE = {
    name: "Ține(te) de noi",
    tagline: "Ajutor practic și organizare pentru viața de acasă",
    phoneDisplay: "+40 778 765 246",
    phoneHref: "tel:+40778765246",
    phone2Display: "+40 771 893 358",
    phone2Href: "tel:+40771893358",
    whatsapp: "https://wa.me/40778765246",
    email: "barburazvanandrei7@gmail.com",
    schedule: "Luni – Vineri, 09:00 – 18:00",
    area: "București – Ilfov",
    domain: "tinedenoi.ro",
};

export const NAV_LINKS = [
    { href: "#servicii", label: "Servicii" },
    { href: "#cum-functioneaza", label: "Cum funcționează" },
    { href: "#preturi", label: "Prețuri" },
    { href: "#echipa", label: "Echipă" },
    { href: "#contact", label: "Contact" },
];
